import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Flex, Spinner } from '@chakra-ui/react';

import useAuth from '../../hooks/useAuth/useAuth';
import { extensionsRoutes } from '../../pages/Routes';

const Logout = () => {
  const navigate = useNavigate();

  const { clearAuth } = useAuth();

  useEffect(() => {
    setTimeout(() => {
      clearAuth();
      navigate(extensionsRoutes.Login, { replace: true });
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex
      justifyContent="center"
      height="80vh"
      width="100%"
      alignItems="center"
    >
      <Spinner />
    </Flex>
  );
};

export default Logout;
